<div class="about-us-container">
    <div class="hero-section">
      <div class="overlay"></div>
      <div class="hero-content">
        <h1>Über uns</h1>
        <p class="tagline">Unsere Leidenschaft für natürliche Kräuter</p>
      </div>
    </div>
  
    <div class="content-section">
      <div class="about-story">
        <h2>Unsere Geschichte</h2>
        <div class="divider"></div>
        <p>
            Herzlich willkommen bei {{ brandName }}! Wir sind ein leidenschaftliches Team von Kräuterexperten und Naturliebhabern, 
            die es sich zur Aufgabe gemacht haben, das Wissen zu gängigen Kräutern mit Euch zu teilen so dass jedes Gericht zum Festmahl wird. Außerdem gibt es hier viele nützliche Informationen
            zu Heilkräutern und Anbautipps!
        </p>
        <p>
            Was als kleine Leidenschaft beim gemeinsamen Kochen begann, wuchs zu einem umfassenden Projekt heran. Bei einer Wanderung durch die Alpen 
            entdeckten wir die Vielfalt und Wirkung heimischer Kräuter und waren fasziniert, wie sehr sie Gerichte verfeinern und 
            gleichzeitig unser Wohlbefinden unterstützen können. Diese Begeisterung wollen wir teilen und euch dabei helfen, die Welt der Kräuter für 
            eure Küche und euer Wohlbefinden zu entdecken.
        </p>
      </div>
  
      <div class="mission-section">
        <h2>Unsere Mission</h2>
        <div class="divider"></div>
        <div class="mission-cards">
          <div class="mission-card">
            <div class="icon-container">
              <i class="mission-icon knowledge"></i>
            </div>
            <h3>Wissen teilen</h3>
            <p>Wir möchten fundiertes und verlässliches Wissen über Kräuter und ihre Anwendungsmöglichkeiten zugänglich machen.</p>
          </div>
          <div class="mission-card">
            <div class="icon-container">
              <i class="mission-icon quality"></i>
            </div>
            <h3>Qualität fördern</h3>
            <p>Wir empfehlen nur Produkte, deren Qualität und Nachhaltigkeit wir selbst überprüft haben.</p>
          </div>
          <div class="mission-card">
            <div class="icon-container">
              <i class="mission-icon sustainability"></i>
            </div>
            <h3>Nachhaltigkeit leben</h3>
            <p>Unsere Arbeit ist von dem Gedanken getragen, im Einklang mit der Natur zu leben und sie zu schützen.</p>
          </div>
        </div>
      </div>
  
      <div class="values-section">
        <h2>Unsere Werte</h2>
        <div class="divider"></div>
        <div class="values-content">
          <div class="values-image">
            <img fill [ngSrc]="imageService.getBaseOptimizedUrl('images/6801282a0f5d5c2f6c01ae63')">
          </div>
          <div class="values-text">
            <ul>
              <li><strong>Authentizität:</strong> Wir teilen nur Informationen, die wissenschaftlich fundiert sind oder auf langjähriger Erfahrung basieren.</li>
              <li><strong>Transparenz:</strong> Wir legen offen, welche Produkte wir empfehlen und warum wir dies tun.</li>
              <li><strong>Nachhaltigkeit:</strong> Wir fördern einen bewussten und nachhaltigen Umgang mit Kräutern und der Natur.</li>
              <li><strong>Gemeinschaft:</strong> Wir schätzen den Austausch mit unseren Lesern und der Kräuter-Community. Schreibt uns gerne per Mail!</li>
            </ul>
            <p class="cta-text">
              Gerne kannst du uns über die Mailadresse <b>{{ contactEmail }}</b> erreichen. <br> <br>
              Wir freuen uns über deine Nachricht!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

